import { MenuItem, Select } from "@mui/material";
import React from "react";

interface LanguageLevelDropdownProps {
  value: string;
  setSelectedLevel: React.Dispatch<React.SetStateAction<string>>;
}

export const LanguageLevelDropdown: React.FC<LanguageLevelDropdownProps> = ({
  value,
  setSelectedLevel,
}) => {
  return (
    <Select
      value={value}
      id="languageLevel"
      // value={formData.position}
      label="Level"
      onChange={(e) => setSelectedLevel(e.target.value)}
      sx={{
        background: "none",
      }}
    >
      <MenuItem value="Basic">Basic</MenuItem>
      <MenuItem value="Advanced">Advanced</MenuItem>
    </Select>
  );
};
